import './GlobalStyle.css';

function GlobalStyle({children}){
    return children;
}

export default GlobalStyle;